import { render, staticRenderFns } from "./VehicleWidget.vue?vue&type=template&id=258e1d10&scoped=true&"
import script from "./VehicleWidget.vue?vue&type=script&lang=js&"
export * from "./VehicleWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehicleWidget.vue?vue&type=style&index=0&id=258e1d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e1d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258e1d10')) {
      api.createRecord('258e1d10', component.options)
    } else {
      api.reload('258e1d10', component.options)
    }
    module.hot.accept("./VehicleWidget.vue?vue&type=template&id=258e1d10&scoped=true&", function () {
      api.rerender('258e1d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleWidget.vue"
export default component.exports